<template>
    <b-container fluid>
        <b-row>
            <b-col lg="12" sm="12">
                <iq-card>
                    <template v-slot:body>
                        <b-overlay rounded="sm" :show="loader">
                            <b-col xs="12" sm="12" md="12" class="text-right mb-2 pr-0">
                                <b-button-group>
                                    <b-button @click="pdfExport()" variant="success">{{  $t('globalTrans.export_pdf') }}</b-button>
                                </b-button-group>
                            </b-col>
                            <b-row class="details">
                                <b-col lg="12" sm="12">
                                    <b-row>
                                        <b-col lg="12" sm="12">
                                            <b-row>
                                                <b-col lg="12" sm="12">
                                                    <b-row style="padding-left:5px">
                                                        <b-col lg="7" sm="7">
                                                            <div class="text-dark font-weight-bold w-35 float-left">{{ $t('globalTrans.organization') }}</div>
                                                            <div class="text-dark">: {{ getOrgName(formData.org_id) }}</div>
                                                        </b-col>
                                                        <b-col lg="5" sm="5">
                                                            <div class="text-dark font-weight-bold w-35 float-left">{{ $t('tp_management.circular_no')}}</div>
                                                            <div class="text-dark">: {{ getCircularMemo(formData.circular_id) }}</div>
                                                        </b-col>
                                                        <b-col lg="7" sm="7">
                                                            <div class="text-dark font-weight-bold w-35 float-left">{{ $t('elearning_config.training')}}</div>
                                                            <div class="text-dark">: {{ getTrainingName(formData.training_name_id) }}</div>
                                                        </b-col>
                                                        <b-col lg="5" sm="5">
                                                            <div class="text-dark font-weight-bold w-35 float-left">{{ $t('elearning_config.batch')}}</div>
                                                            <div class="text-dark">: {{ getBatch(formData.batch_id) }}</div>
                                                        </b-col>
                                                        <b-col lg="7" sm="7">
                                                            <div class="text-dark font-weight-bold w-35 float-left">{{ $t('trainer_trainee.trainers')}} {{ $t('globalTrans.name')}}</div>
                                                            <div class="text-dark">: {{ $i18n.locale === 'en' ? formData.trainer_name : formData.trainer_name_bn }}</div>
                                                        </b-col>
                                                        <b-col lg="5" sm="5">
                                                            <div class="text-dark font-weight-bold w-35 float-left">{{ $t('globalTrans.fiscal_year')}}</div>
                                                            <div class="text-dark">: {{ getFiscalYear(formData.fiscal_year_id) }}</div>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row class="mt-2">
                                                        <b-col lg="12" sm="12">
                                                            <div v-if="formData.details.length > 0">
                                                                <b-table-simple class="mt-3" bordered hover small caption-top responsive>
                                                                    <b-thead>
                                                                        <b-tr class="bg-primary">
                                                                            <th class="text-center" style="width:1% !important">{{ $t('globalTrans.sl_no') }}</th>
                                                                            <th>{{$t('tp_management.course')}}</th>
                                                                        </b-tr>
                                                                    </b-thead>
                                                                    <b-tbody>
                                                                        <tr v-for="(item, index) in formData.details" :key="index">
                                                                            <td class="text-center">{{ $n(index + 1) }}</td>
                                                                            <td>
                                                                                {{ $i18n.locale === 'en' ? item.course_name.name : item.course_name.name_bn }}
                                                                            </td>
                                                                        </tr>
                                                                    </b-tbody>
                                                                </b-table-simple>
                                                            </div>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>
                                            </b-row>
                                            <div class="row">
                                                <div class="col-sm-3"></div>
                                                <div class="col text-right">
                                                    <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-2')">{{ $t('globalTrans.close') }}</b-button>
                                                </div>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-overlay>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import { trainingElearningServiceBaseUrl } from '@/config/api_config'
import ExportPdf from './export-pdf_details'
export default {
    name: 'FormLayout',
    props: ['id'],
    components: {
    },
    created () {
        if (this.id) {
            const tmp = this.getData()
            this.formData.fiscal_year_id = tmp.fiscal_year_id
            this.formData.org_id = tmp.org_id
            this.formData.circular_id = tmp.circular_id
            this.formData.training_name_id = tmp.training_name_id
            this.formData.batch_id = tmp.batch_id
            this.formData.trainer_id = tmp.trainer_id
            this.formData.trainer_name = tmp.trainer.name
            this.formData.trainer_name_bn = tmp.trainer.name_bn
            this.formData.details = tmp.details
        }
    },
    mounted () {
        core.index()
    },
    data () {
        return {
            ItemShow: false,
            loader: false,
            formData: {
                fiscal_year_id: 0,
                org_id: 0,
                circular_id: 0,
                training_name_id: 0,
                batch_id: 0,
                trainer_id: 0,
                trainer_name: '',
                trainer_name_bn: '',
                details: [{
                    course_id: ''
                }]
            }
        }
    },
    computed: {
    },
    watch: {
    },
    methods: {
        getData () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return JSON.parse(JSON.stringify(tmpData))
        },
        getOrgName (id) {
            const obj = this.$store.state.commonObj.organizationProfileList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return obj.text_bn
            } else {
                return obj.text
            }
        },
        getFiscalYear (id) {
            const obj = this.$store.state.commonObj.fiscalYearList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return obj.text_bn
            } else {
                return obj.text
            }
        },
        getTrainingName (id) {
            const obj = this.$store.state.TrainingElearning.commonObj.trainingNameList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return obj.text_bn
            } else {
                return obj.text
            }
        },
        getCircularMemo: function (id) {
            const obj = this.$store.state.TrainingElearning.commonObj.circularMemoList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return obj.text_bn
            } else {
                return obj.text
            }
        },
        getBatch: function (id) {
            const obj = this.$store.state.TrainingElearning.commonObj.batchList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return obj.text_bn
            } else {
                return obj.text
            }
        },
        getTrainerName: function (id) {
            const obj = this.trainerList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return obj.text_bn
            } else {
                return obj.text
            }
        },
        pdfExport () {
            const reportTitle = this.$t('tp_management.assign_course_trainer') + ' ' + this.$t('globalTrans.details')
            ExportPdf.exportPdfDetails(trainingElearningServiceBaseUrl, 'config/report-heading/detail', 4, reportTitle, this.formData, this)
        }
    }
}
</script>
